import { t } from 'i18next';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { TOP_MENU_BAR_HEIGHT } from '../../components/TopMenuBar.tsx/constants';
import { cleanAccountSettingsState } from '../../redux/accountSettingsPage/accountSettingsSlice';
import { colors } from '../../theme/colors';
import spacing, {
  isMobileScreen,
  pageContentContainerSpacing,
} from '../../theme/spacing';
import { fontSize } from '../../theme/typography';
import AccountSettingsPageModals from './AccountSettingsPageModals';
import AccountSettingsDefaultLocationField from './Fields/AccountSettingsDefaultLocationField';
import AccountSettingsDeleteAccountField from './Fields/AccountSettingsDeleteAccountField';
import AccountSettingsNameField from './Fields/AccountSettingsNameField';
import AccountSettingsLanguageField from './Fields/AccountSettingsLanguageField';
import AccountSettingsBlockedUsersField from './Fields/AccountSettingsBlockedUsersField';
import { useFetchCurrentUserFreshData } from '../../graphql/apis/users/queries/hooks/useFetchCurrentUserFreshData';
import AccountSettingsProfileImageField from './Fields/AccountSettingsProfileImageField';
import AccountSettingsNotificationsField from './Fields/AccountSettingsNotificationsField';
import Footer from '../../components/Footer';
import { useScrollToWindow } from '../RootPage/hooks/useScrollToWindow';

const AccountSettingsPage = () => {
  const dispatch = useDispatch();
  const { scrollToWindowTop } = useScrollToWindow();

  useFetchCurrentUserFreshData();

  useEffect(() => {
    scrollToWindowTop({ smooth: false });

    return () => {
      dispatch(cleanAccountSettingsState());
    };
  }, [scrollToWindowTop, dispatch]);

  return (
    <div
      style={{
        ...pageContentContainerSpacing.regular,
        paddingTop: TOP_MENU_BAR_HEIGHT,
      }}
    >
      <div
        style={{
          color: colors.textPrimary,
          marginBottom: spacing.large,
          fontSize: isMobileScreen ? fontSize['2xl'] : fontSize['3xl'],
          fontWeight: 'bold',
        }}
      >
        {t('accountSettings.title')}
      </div>

      <div style={{ marginBottom: spacing.medium }}>
        <AccountSettingsProfileImageField />
      </div>

      <div
        style={{
          marginBottom: spacing.medium,
        }}
      >
        <AccountSettingsNameField />
      </div>

      <div
        style={{
          marginBottom: spacing.mediumLarge,
        }}
      >
        <AccountSettingsDefaultLocationField />
      </div>

      <div
        style={{
          marginBottom: spacing.mediumLarge,
        }}
      >
        <AccountSettingsLanguageField />
      </div>

      <div
        style={{
          marginBottom: spacing.mediumLarge,
        }}
      >
        <AccountSettingsNotificationsField />
      </div>

      <div
        style={{
          marginBottom: spacing.mediumLarge,
        }}
      >
        <AccountSettingsBlockedUsersField />
      </div>

      <AccountSettingsDeleteAccountField />

      <Footer />

      <AccountSettingsPageModals />
    </div>
  );
};

export default AccountSettingsPage;
